import { lazy, type ComponentType, type LazyExoticComponent } from "react";

/**
 * Lazy tool registry — a user without a tool grant never downloads its chunk.
 * Adding the next tool = folder under `tools/` + entry here + BE manifest.
 */
export const TOOL_LAZY_REGISTRY: Record<
  string,
  LazyExoticComponent<ComponentType<Record<string, never>>>
> = {
  operators: lazy(async () => {
    const module = await import("./operators/OperatorsToolLayout");
    return { default: module.OperatorsToolLayout };
  }),
  dashboards: lazy(async () => {
    const module = await import("./dashboards/DashboardsToolLayout");
    return { default: module.DashboardsToolLayout };
  }),
  "event-queue": lazy(async () => {
    const module = await import("./event-queue/EventQueueToolLayout");
    return { default: module.EventQueueToolLayout as ComponentType<Record<string, never>> };
  }),
  okrs: lazy(async () => {
    const module = await import("./okrs/OkrsToolLayout");
    return { default: module.OkrsToolLayout as ComponentType<Record<string, never>> };
  }),
};

export function getLazyToolComponent(slug: string) {
  return TOOL_LAZY_REGISTRY[slug] ?? null;
}
